<template>
    <div>
        <TopAppBar
            :leftBtnMode="leftBtnMode"
            :rightBtnMode="rightBtnMode"
            :title="title"
            :leftBtnMethod="leftBtnMethod"
            :rightBtnMethod="rightBtnMethod"
        >
        </TopAppBar>
        <div class="mdc-drawer-app-content mdc-top-app-bar--fixed-adjust add-tab">
            증명서    
        </div>
        
        
        
    </div>
</template>

<script>
/**
 * 인증서 메인 컴포넌트(Certification main component) 
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import TopAppBar from '@/components/TopAppBar.vue'
import {topAppBarMixin} from '@/mixins/topAppBar.js'
import LearnList from '@/components/learn/List'

export default {
    name: 'certification',

    data() {
        return {
        }
    },
    components: {
        TopAppBar,
    },

    mixins: [topAppBarMixin],

    mounted() {
        this.setTopAppBarBackSearch('증명서')
    },

    updated() {
        
    }
}
</script>


<style>
    
</style>
